import * as THREE from "three";

export function createBodyPart(width, height, depth, materials, x, y, z) {
  const geometry = new THREE.BoxGeometry(width, height, depth);
  const mesh = new THREE.Mesh(geometry, materials);
  mesh.position.set(x, y, z);
  return mesh;
}

export function getTexture(texture, x, y, width, height, isTransparent = false) {
  if (!texture.image) {
    console.error("Texture image not loaded");
    return new THREE.MeshBasicMaterial({ color: 0xff0000 }); // Fallback red material
  }

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext("2d");
  context.imageSmoothingEnabled = false;
  context.drawImage(texture.image, x, y, width, height, 0, 0, width, height);
  const newTexture = new THREE.CanvasTexture(canvas);
  newTexture.magFilter = THREE.NearestFilter;
  newTexture.minFilter = THREE.NearestFilter;
  return new THREE.MeshLambertMaterial({
    map: newTexture,
    transparent: isTransparent,
    alphaTest: isTransparent ? 0.1 : 0.0,
    side: isTransparent ? THREE.DoubleSide : THREE.FrontSide,
  });
}

export function createShadowDisc() {
  const canvas = document.createElement("canvas");
  canvas.width = 64;
  canvas.height = 64;
  const ctx = canvas.getContext("2d");
  const gradient = ctx.createRadialGradient(32, 32, 0, 32, 32, 30);
  gradient.addColorStop(0, "rgba(0, 0, 0, 0.55)");
  gradient.addColorStop(0.6, "rgba(0, 0, 0, 0.2)");
  gradient.addColorStop(1, "rgba(0, 0, 0, 0)");
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, 64, 64);

  const texture = new THREE.CanvasTexture(canvas);
  const geometry = new THREE.PlaneGeometry(12 / 64, 9 / 64);
  const material = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true,
    depthWrite: false,
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.rotation.x = -Math.PI / 2;
  mesh.position.set(0, 0.001, 0);
  return mesh;
}
